import { memo } from 'react'
import BodySmall from 'd2/components/Typography/BodySmall'
import useStyle from '../styles'
import useTranslations from '../translations'

const CleanTag = memo<EO>(() => {
  const t = useTranslations()
  const { classes } = useStyle()

  return (<BodySmall
    className={classes.margin}
    color='success'
    variant='semibold-italic'
  >
    { t.clean }
  </BodySmall>)
})

CleanTag.displayName = 'CleanTag'

export default CleanTag
